const padding = 50;

function shuffle(a) {
    var currentIndex = a.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = a[currentIndex];
      a[currentIndex] = a[randomIndex];
      a[randomIndex] = temporaryValue;
    }
  
    return a;
}

const makePup = (i) => ({
    id: 'p' + (i+1),
    background: "#CCCCCC",
    fg_color: "#CCCCCC",

    src: 'content/'+(i+1)+'-pup.png',

    nativeWidth: 640,
    nativeHeight: 480,


    width: 640/4,
    height: 480/4,

    x: (0 + Math.floor(i/4)) * (640/4 + padding) - 200,
    y: 8400 + (i)%4 * (480/4 + padding)
});

const makeKitten = i => ({
    id: 'k' + (i+1),
    background: "#CCCCCC",
    fg_color: "#CCCCCC",

    src: 'content/'+(i+1)+'-kitten.png',

    nativeWidth: 640,
    nativeHeight: 480,

    width: 640/4,
    height: 480/4,



    x: (4 + Math.floor(i/4)) * (640/4 + padding) - 200,
    y: 8400 +(i)%4 * (480/4 + padding)
});
const makeTextImg = (i) => ({
    id: 't' + (i+1),
    background: "#CCCCCC",
    fg_color: "#CCCCCC",

    src: 'content/'+(i+1)+'-text.png',

    nativeWidth: 640,
    nativeHeight: 480,

    width: 640/4,
    height: 480/4,

    x: (2 + Math.floor(i/4)) * (640/4 + padding) - 200,
    y: 8400 +(i)%4 * (480/4 + padding)
});
const makeAbstract = (i) => ({
    id: 'a' + (i+1),
    background: "#CCCCCC",
    fg_color: "#CCCCCC",

    src: 'content/'+(i+1)+'-abstract.png',

    nativeWidth: 640,
    nativeHeight: 480,

    width: 640/4,
    height: 480/4,

    x: (6 + Math.floor(i/4)) * (640/4 + padding) - 200,
    y: 8400 +(i)%4 * (480/4 + padding)
});

const makeText = (i, content) => {
    let size = 2;//Math.random()*4+1;

    const scale = 1;//i == 2 ? 0.47 : 1;
    const autoSize = i == 2 ? 1 : 1;
    const verticalAlignTop = i==2 ;

    return {
        id: 'txt' + (i+1),
        background: "#CCCCCC",
        fg_color: "#CCCCCC",

        type: 'text',
        content: content,

        width: size*100,
        height: size*100,

        x: (i%4) * (-400/2 + padding) - 200,
        y: -300 + (i)%3 * (180/2 + padding),
        scale,//Math.random()*4+1,
        autoSize,
        verticalAlignTop
        // x: -410,
        // y: 3180
    }
};

const makeDoc = (i) => {
    return {
        id: 'd' + (i+1),
        background: "#CCCCCC",
        fg_color: "#CCCCCC",
    
        src: [
            'content/'+(i+1)+'-icon.png',
            'content/'+(i+1)+'-doc-icon.png',
            'content/'+(i+1)+'-doc.png'        
        ],
    
        nativeWidth: 640,
        nativeHeight: 480,
    
        width: 640,
        height: 480,
    
        x: -600 + (Math.floor(i/4)) * (640 + padding),
        y: -1200 + (i)%4 * (480 + padding),

        mix: [
            {
              minZoom: 0,
              maxZoom: 0,
            //   fadeZoom: .5
            },
            {
              minZoom: 0,
              maxZoom: .25,
            //   fadeZoom: .5
            },
            {
              minZoom: .25,
              maxZoom: 16,
            //   fadeZoom: .5
            }
          ]
    }



}


let defaultContent = [];
let set1 = [];
let set2 = [];

for (var i=0;i<8; i++) {
    set2.push(makePup(i));
    set2.push(makeAbstract(i));
    set2.push(makeKitten(i));    
    set2.push(makeTextImg(i));    
}

set2 = shuffle(set2);

for (var j=0, len=set2.length; j<len; j++) {
    let item = set2[j];
    let itemCopy = Object.assign({}, item, 
        {
            id: 'lg' + item.id,
            width: item.nativeWidth,
            height: item.nativeHeight,
            x: (Math.floor(j/8)) * (640 + padding) + 200,
            y: -4000 + (j)%8 * (480 + padding)
        }
    );
    set1.push(itemCopy);
}

let set3 = [];
//<shape style="font-size: 3rem;">
//Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!
// set3.push(makeText(0, 'Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!Hello  x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x x xx x x x x x x  World!'));
// set3.push(makeText(1, 'Hello x x x x x x x x x x x x x @ x x x x x x x x # x x x x x x x x + x x x x x x x x * x x xx x x x x x -'));
// set3.push(makeText(2, 'Hello x x x x x x x x @ x x x # x x x x x x x x + x x x x x x x x * x x xx x x x x x -'));
// set3.push(makeText(3, 'Hello x x x x x x x x @ x x x # x x x x x x x x + x x x x'))
set3.push(makeText(0, 'Hello World'));
set3.push(makeText(1, 'Once upon a time in a galaxy far far away...'));
set3.push(makeText(2, '<span class="diamond-left">&nbsp;</span><span class="diamond-right">&nbsp;</span><p>This is an experimental shape fill and not 100% working yet. This is an experimental shape fill and not 100% working yet. This is an experimental shape fill and not 100% working yet. This is an experimental shape fill and not 100% working yet.</p>'));
set3.push(makeText(3, '<p class="ql-align-left">left</p><p class="ql-align-center">center</p><p class="ql-align-right">right</p>'));

set3.push(makeText(4, '<p class="ql-align-center">😇</p>'));
set3[set3.length-1].x = -20;
set3[set3.length-1].y = 20;

set3.push(makeText(5, '<p class="ql-align-center">😈</p>'));
set3[set3.length-1].x = -180;
set3[set3.length-1].y = 140;

let set4 = [];
// for (var i=0; i<3; i++) {
//     set4.push(makeDoc(i));
// }


defaultContent = defaultContent.concat(set1, set2, set3);//, set3, set4);
// console.log(defaultContent);

export default defaultContent; 